import * as L from 'leaflet';
import 'proj4';
import 'proj4leaflet';

export const finCRS = new L.Proj.CRS('EPSG:3067', '+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',{
  resolutions: [ 2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5 ]
});